import { Section, highlight } from "./shared";

function HorizontalTimeline({ items, regex }) {
  return (
    <div className="relative">
      <div
        className="overflow-x-auto overflow-y-hidden pb-3 -mx-1 px-1 timeline-scroll"
        data-testid="timeline-horizontal-scroll"
      >
        <div className="relative min-w-max pt-2">
          <div className="absolute left-0 right-0 top-[22px] h-0.5 bg-[#3B82F6]" />
          <ol className="flex items-start gap-6">
            {items.map((t, i) => (
              <li key={i} className="relative flex-shrink-0 w-48 pt-6">
                <span className="absolute left-0 top-[16px] w-3 h-3 bg-[#3B82F6] border-2 border-black rounded-full" />
                <p className="font-mono text-[10px] uppercase tracking-widest text-[#3B82F6]">{t.date}</p>
                <p className="font-heading font-bold mt-0.5 text-sm whitespace-normal">
                  {highlight(t.event, regex)}
                </p>
                {t.significance && (
                  <p className="text-zinc-700 text-xs mt-0.5 whitespace-normal">
                    {highlight(t.significance, regex)}
                  </p>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
      <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-zinc-500">
        &larr; scroll horizontally &rarr; ({items.length} events)
      </p>
    </div>
  );
}

export function TimelineSection({ timeline, regex }) {
  if (!timeline?.length) return null;
  return (
    <Section label="Timeline">
      {timeline.length >= 10 ? (
        <HorizontalTimeline items={timeline} regex={regex} />
      ) : (
        <ol className="relative border-l-2 border-[#3B82F6] pl-4 space-y-3">
          {timeline.map((t, i) => (
            <li key={i} className="text-sm">
              <span className="absolute -left-[7px] w-3 h-3 bg-[#3B82F6] border-2 border-black rounded-full" />
              <p className="font-mono text-[10px] uppercase tracking-widest text-[#3B82F6]">{t.date}</p>
              <p className="font-heading font-bold mt-0.5">{highlight(t.event, regex)}</p>
              {t.significance && (
                <p className="text-zinc-700 text-xs mt-0.5">{highlight(t.significance, regex)}</p>
              )}
            </li>
          ))}
        </ol>
      )}
    </Section>
  );
}
